import React, { useEffect, useState } from "react";
import { History, ChevronDown } from "lucide-react";
import api, { fmtIDR } from "../../lib/api";
import { inputCls, Panel } from "./ui";

const fmtAt = (s) => new Date(s).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "short" });

function HistRow({ h }) {
  const [open, setOpen] = useState(false);
  const bulk = h.type === "bulk";
  const oldTxt = h.old != null ? fmtIDR(h.old) : (h.old_values || []).map(fmtIDR).join(", ");
  return (
    <>
      <tr data-testid={`phist-row-${h.id}`} className="border-b border-[#35353B]">
        <td className="py-2 pr-3 text-xs text-[#A8A8AD] whitespace-nowrap">{fmtAt(h.at)}</td>
        <td className="py-2 pr-3 text-[#F5F3ED]">{h.by}</td>
        <td className="py-2 pr-3"><span className={`text-[10px] uppercase tracking-widest border rounded-full px-2 py-0.5 ${bulk ? "text-[#D4AF37] border-[#D4AF37]" : "text-[#5FC3F0] border-[#5FC3F0]"}`}>{bulk ? "Massal" : "Manual"}</span></td>
        <td className="py-2 pr-3 text-[#F5F3ED]">{h.game_name} · {bulk ? `${h.count} produk${h.override_custom ? " (timpa khusus)" : ""}` : h.product_name}</td>
        <td className="py-2 pr-3 text-right whitespace-nowrap"><span className="text-[#A8A8AD]">{oldTxt}</span> → <span className="font-bold text-[#D4AF37]">{fmtIDR(h.new)}</span></td>
        <td className="py-2">{bulk && <button data-testid={`phist-expand-${h.id}`} onClick={() => setOpen(!open)} className="text-[#A8A8AD] hover:text-[#D4AF37]"><ChevronDown size={14} className={`transition-transform ${open ? "rotate-180" : ""}`} /></button>}</td>
      </tr>
      {open && <tr className="bg-[#191A1F]/60"><td colSpan="6" className="px-3 py-2 text-xs text-[#A8A8AD] space-y-0.5">{(h.items || []).map((i) => <div key={i.product_id}>{i.product_name}: {fmtIDR(i.old)} → {fmtIDR(h.new)}</div>)}</td></tr>}
    </>
  );
}

export default function PriceHistoryPanel({ games, refreshKey }) {
  const [rows, setRows] = useState(null);
  const [gameId, setGameId] = useState("");
  const [q, setQ] = useState("");
  useEffect(() => {
    const id = setTimeout(() => {
      api.get("/admin/price-history", { params: { game_id: gameId || undefined, q: q.trim() || undefined } }).then((r) => setRows(r.data));
    }, 300);
    return () => clearTimeout(id);
  }, [gameId, q, refreshKey]);
  return (
    <Panel title="Riwayat Harga" testId="price-history-panel">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-4">
        <select data-testid="phist-game" className={inputCls} value={gameId} onChange={(e) => setGameId(e.target.value)}>
          <option value="">Semua game</option>
          {games.map((g) => <option key={g.id} value={g.id}>{g.name}</option>)}
        </select>
        <input data-testid="phist-search" placeholder="Cari produk / server" className={`${inputCls} md:col-span-2`} value={q} onChange={(e) => setQ(e.target.value)} />
      </div>
      {rows === null ? <p className="text-sm text-[#A8A8AD]">Memuat...</p> : rows.length === 0 ? (
        <p data-testid="phist-empty" className="text-sm text-[#A8A8AD] flex items-center gap-2"><History size={15} /> Belum ada perubahan harga.</p>
      ) : (
        <div className="overflow-x-auto max-h-[420px] overflow-y-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-[10px] uppercase tracking-widest text-[#A8A8AD] border-b border-[#35353B]"><th className="py-2">Waktu</th><th>Oleh</th><th>Jenis</th><th>Produk</th><th className="text-right pr-3">Harga</th><th /></tr></thead>
            <tbody>{rows.map((h) => <HistRow key={h.id} h={h} />)}</tbody>
          </table>
        </div>
      )}
    </Panel>
  );
}
